import * as S from './styles.ts';
import DynamicIcon from '@template/components/DynamicIcon';
import { ColorKey } from '@template/theme/types/color.type.ts';

type HTMLDivProps = typeof HTMLDivElement;

export interface IPillProps extends Partial<HTMLDivProps> {
  children?: any;
  icon?: string;
  color?: ColorKey;
  variant?: 'ghost' | 'flat' | 'solid' | 'outline' | 'light';
  size?: 'sm' | 'md';
}

export const Pill = ({
  icon,
  color = 'primary',
  variant = 'flat',
  size = 'md',
  children,
  ...props
}: IPillProps) => {
  return (
    <S.PillWrapper $variant={variant} $color={color} $size={size} {...props}>
      {icon && <DynamicIcon name={icon} />}
      {children && <S.PillText>{children}</S.PillText>}
    </S.PillWrapper>
  );
};

export default Pill;
